<script setup lang="ts">
import { RouterLink } from 'vue-router'

const primaryLinks = [
  { label: 'Home', to: '/', code: '00' },
  { label: 'Ship', to: '/ship', code: '01' },
  { label: 'Track', to: '/track', code: '02' },
  { label: 'Services', to: '/ship', code: '03' },
  { label: 'Locations', to: '/locations', code: '04' },
  { label: 'Get a quote', to: '/quote', code: '05' },
  { label: 'Contact', to: '/contact', code: '06' },
]
</script>

<template>
  <aside class="site-rail" aria-label="Primary navigation">
    <RouterLink class="site-rail__brand" to="/" aria-label="Carib Wave Logistics home">
      <picture>
        <source srcset="/logo-256.avif" type="image/avif" />
        <source srcset="/logo-256.webp" type="image/webp" />
        <img src="/logo-256.png" alt="" width="256" height="256" />
      </picture>
      <span>Carib Wave</span>
    </RouterLink>

    <nav class="route-nav">
      <span class="route-nav__origin" aria-hidden="true">US</span>
      <RouterLink
        v-for="link in primaryLinks"
        :key="link.to"
        class="route-nav__link"
        :to="link.to"
      >
        <span class="route-nav__node" aria-hidden="true"></span>
        <span class="route-nav__code" aria-hidden="true">{{ link.code }}</span>
        <span>{{ link.label }}</span>
      </RouterLink>
      <span class="route-nav__destination" aria-hidden="true">JA</span>
    </nav>

    <div class="site-rail__account" aria-label="Account actions">
      <a class="site-rail__login" href="https://portal.caribwaveja.com">Log in</a>
      <a class="site-rail__signup" href="https://portal.caribwaveja.com/signup">
        <span>Sign up</span>
        <span aria-hidden="true">↗</span>
      </a>
    </div>
  </aside>
</template>
